/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HintBox from "../../Box/HintBox/HintBox";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import PowerOfAttorneyIntroHighlightBox from "./PowerOfAttorneyIntroHighlightBox";
import PowerOfAttorneyNextSteps from "../Common/PowerOfAttorney/PowerOfAttorneyNextSteps";

type PowerOfAttorneyIntroHintBoxProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

export default function PowerOfAttorneyIntroHintBox({ product, submitProps }: PowerOfAttorneyIntroHintBoxProps) {
  return (
    <>
      {!submitProps.isMinimal && (
        <HintBox headline={"So geht es weiter"}>
          <PowerOfAttorneyNextSteps
            bulletPoints={[
              "Sie erteilen uns die Vollmacht, damit wir Sie vertreten dürfen.",
              "Wir prüfen Ihren Verkehrsunfall unverbindlich für Sie und melden uns dann umgehend bei Ihnen zurück.",
              "Wir setzen uns mit dem KFZ-Haftpflichtversicherer Ihres Unfallgegners in Verbindung und versuchen, Ihre Forderung außergerichtlich geltend zu machen.",
              "Sollte eine außergerichtliche Klärung nicht möglich sein, vertreten wir Sie selbstverständlich auch im gerichtlichen Verfahren.",
            ]}
          />
          <PowerOfAttorneyIntroHighlightBox product={product} />
        </HintBox>
      )}
    </>
  );
}
